module.exports = __webpack_public_path__ + "7f8dc7a0632a5459e08069effd588acb.pdf";